<template>
  <b-col md="12" class="mb-4 pb-2">
    <section class="reservation">
      <p class="reservation__title">
        {{ get_config('site.brand') }} è l'agenzia a cui fare riferimento per quello che riguarda la prenotazione,
        ad esempio informazioni, modifiche, cancellazione ove possibile o altre richieste di assistenza.
      </p>
      <div class="reservation__wrap">
        Contattaci qui:
        <ul>
          <li>mail: <a :href="`mailto:${get_config('site.emailSupport')}`">{{ get_config('site.emailSupport') }}</a></li>
          <li>whatsapp: {{ get_config('site.mobileNumber') }}</li>
          <li>telefono: {{ get_config('site.phoneNumber') }}</li>
        </ul>
        Problemi in loco? Il primo passo è contattare la struttura prenotata. Se la situazione non si risolve, siamo qui per aiutarti.<br>
        Se tuttavia scegli di non soggiornare, cambiare struttura, o fare modifiche alla prenotazione concordandole con booking.com o direttamente con l'hotel, purtroppo non potremo fornirti assistenza.
      </div>
    </section>
  </b-col>
</template>

<script>

export default {
  name: 'reservation',

  components: {
  },

  props: {
    confirm: Object
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .reservation {
    background-color: #fafcff;
    border-radius: 10px;
    padding: 15px 20px;
    border: 1px solid $gray-300;
    height: 100%;
    margin-top: $grid-gutter-width;

    @include media-breakpoint-up(xl){
      margin-top: 0;
    }

    @media print {
      border: none;
      padding: 0;
      background-color: $white;
    }

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 10px;
      color: var(--info);
    }

    &__wrap {
      ul {
        margin-top: 10px;
        padding-left: $grid-gutter-20;
      }
    }

  }

</style>